import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ImageGalleryErrorsTypes } from '../../typings/banners';
import { ValidationErrorData } from '../../typings/common';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { ContainerOverflow } from '../ContainerOverflow/ContainerOverflow';
import { Loader } from '../Loader/Loader';
import { ScreenErrorMessage } from '../ScreenErrorMessage/ScreenErrorMessage';

import './ImageGallery.css';
import * as keyset from './ImageGallery.i18n';
import { ImageGalleryItem, ImageGalleryItemData } from './ImageGalleryItem/ImageGalleryItem';

const i18n = i18nFactory(keyset);

export enum ImageGalleryType {
    imageAd = 'imageAd',
    textImageAd = 'textImageAd',
    internalImageAd = 'internalImageAd'
}

export interface ImageGalleryProps {
    type: ImageGalleryType;
    images?: Array<ImageGalleryItemData>;
    errors?: Array<ValidationErrorData>;
    imagesSelectedHash: Array<string>;
    onAccept: (imagesHash: Array<string>) => void;
    onCancel: () => void;
    onImageSelect: (id: string) => void;
}

const block = 'image-gallery';

export class ImageGallery extends React.Component<ImageGalleryProps> {
    render() {
        const { images, onCancel, errors, imagesSelectedHash } = this.props;

        return (
            <div className={Bem.cls(block)}>
                <div className={Bem.cls(block, 'header')}>
                    <h3 className={Bem.cls(block, 'title')}>{i18n('title')}</h3>
                    <div className={Bem.cls(block, 'header-text')}>{this.getHelpText()}</div>
                </div>
                <div className={Bem.cls(block, 'body')}>{errors ? this.getError() : this.getImages()}</div>
                <div className={Bem.cls(block, 'footer')}>
                    <ButtonDecorator
                        cls={Bem.cls(block, 'button-accept')}
                        size={'n'}
                        theme={'action'}
                        disabled={images === undefined || !imagesSelectedHash.length}
                        onClick={this.onAcceptGallery}
                        text={i18n('accept')}
                    />
                    <ButtonDecorator
                        cls={Bem.cls(block, 'button-close')}
                        size={'n'}
                        theme={'pseudo'}
                        onClick={onCancel}
                        text={i18n('cancel')}
                    />
                </div>
            </div>
        );
    }

    private getHelpText() {
        const { type } = this.props;

        switch (type) {
            case ImageGalleryType.imageAd:
                return i18n('imageAd-help-text');
            case ImageGalleryType.textImageAd:
            case ImageGalleryType.internalImageAd:
            default:
                return i18n('textImageAd-help-text');
        }
    }

    private getImages() {
        const { images, onImageSelect } = this.props;

        return (
            <ContainerOverflow>
                {images !== undefined ? (
                    images.map((image, key) => <ImageGalleryItem onItemSelect={onImageSelect} key={key} {...image} />)
                ) : (
                    <Loader size={'m'} />
                )}
            </ContainerOverflow>
        );
    }

    private getError() {
        const { errors } = this.props;
        const error = errors![0];

        return (
            <ScreenErrorMessage
                header={error.text}
                text={error.code === ImageGalleryErrorsTypes.INTERNAL_ERROR ? i18n('error-text') : undefined}
                cls={Bem.cls(block, 'error')}
            />
        );
    }

    private onAcceptGallery = () => {
        const { onAccept, imagesSelectedHash } = this.props;

        onAccept(imagesSelectedHash);
    };
}
